import Api from '@/services/api';

export default {
  delete(onboarding) {
    return Api()
      .delete('/onboarding/' + onboarding.id)
      .then(() => onboarding);
  },
  getIds() {
    return Api()
      .get('/onboarding/ids')
      .then((res) => res.data);
  },
  formatRes(e) {
    if (e.shootingDate) e.shootingDate = new Date(e.shootingDate);
    if (e.accommodation && e.accommodation.unavailabilityList) {
      for (let item of e.accommodation.unavailabilityList) {
        if (item.start) item.start = new Date(item.start);
        if (item.end) item.end = new Date(item.end);
      }
    }
    if (e.mandat) {
      if (e.mandat.dateEnd) e.mandat.dateEnd = new Date(e.mandat.dateEnd);
      if (e.mandat.dateStart) e.mandat.dateStart = new Date(e.mandat.dateStart);
    }
    return e;
  },
};
